// A list where each line has an id
import "firebase/compat/firestore";
import firebase from "firebase/compat/app";

class FirebaseTable {
  constructor() {}

  // https://firebase.google.com/docs/firestore/query-data/query-cursors

  get_default_meta_object() {
    return {
      doc_count: 0,
      first_id: 0,
      next_id: 0,
      code: "0000",
      note: "-",
      valid_from: new Date(),
      valid_to: new Date(),
      created: new Date(),
      group: "0",
      personal: true, // Indicatesm that table stores personal data
      open: 1, // indicate, that table can be used 0 = do no use
    };
  }

  async get_count(tName) {
    var h = await this.get_lines(tName);
    return h.length;
  }

  async set_count(tName) {
    var h = await this.get_lines(tName);
    await this.update_meta_field(tName, "doc_count", h.length);
    return h.length
  }

  get_lines_filtered(tName, field, comparison, value, orderField) {
    var query;

    if (orderField) {
      console.log("ys");
      query = firebase
        .firestore()
        .collection("data")
        .doc(tName)
        .collection("entries")
        .where(field, comparison, value)
        .orderBy(orderField, "desc");
    } else {
      query = firebase
        .firestore()
        .collection("data")
        .doc(tName)
        .collection("entries")
        .where(field, comparison, value);
    }

    var promise = query
      .get()
      .then((querySnapshot) => {
        var result = [];
        querySnapshot.forEach((doc) => {
          result.push(doc.data());
        });
        return result;
      })
      .catch((error) => {
        console.log(error);
        return undefined;
      });

    return promise;
  }

  get_lines(tName) {
    console.log("Calles getLines for table  ", tName);
    let res;
    var promise = firebase
      .firestore()
      .collection("data")
      .doc(tName)
      .collection("entries")
      .get()
      .then((querySnapshot) => {
        var res = [];
        querySnapshot.forEach((doc) => {
          res.push(doc.data());
        });
        return res;
      })
      .catch((error) => {
        res = undefined;
      });
    return promise;
  }

  get_lines_with_key(tName) {
    console.log("Calles getLines for table  ", tName);
    let res;
    var promise = firebase
      .firestore()
      .collection("data")
      .doc(tName)
      .collection("entries")
      .get()
      .then((querySnapshot) => {
        var res = [];
        querySnapshot.forEach((doc) => {
          res.push({
            key: doc.id,
            data: doc.data()
          });
        });
        return res;
      })
      .catch((error) => {
        res = undefined;
      });
    return promise;
  }

  get_tables() {
    return firebase
      .firestore()
      .collection("data")
      .get()
      .then((querySnapshot) => {
        var result = [];
        querySnapshot.forEach((doc) => {
          result.push({ id: doc.id, meta: doc.data() });
        });
        console.log("Finished reading from database ....");
        return result;
      })
      .catch((error) => {
        console.log("Error  reading from database ", error);
        return undefined;
      });
  }

  async create_table(name, meta) {
    if (meta === undefined) {
      meta = this.get_default_meta_object();
    }

    var promise = firebase
      .firestore()
      .collection("data")
      .doc(name)
      .set(Object.assign({}, meta))
      .then(() => {
        return 1;
      })
      .catch(function(error) {
        console.log(error);
        return undefined;
      });

    return promise;
  }

  async read_meta(tName) {
    var promise = firebase
      .firestore()
      .collection("data")
      .doc(tName)
      .get()
      .then((doc) => {
        if (doc.exists) {
          console.log("Entry exists...: ", doc.data());
          return { id: doc.id, meta: doc.data() };
        } else {
          console.log("Entry not found ...: " + tName);
          return undefined;
        }
      })
      .catch(function(error) {
        console.error("Error check existstence of document:  ", error);
        return undefined;
      });

    return promise;
  }

  async read_by_key(tName, key) {
    console.log("Checking  " + key);
    var promise = firebase
      .firestore()
      .collection("data")
      .doc(tName)
      .collection("entries")
      .doc(key)
      .get()
      .then((doc) => {
        if (doc.exists) {
          console.log("Entry exists...: ", doc.data());
          return doc.data();
        } else {
          console.log("Entry not found ...: " + key);
          return undefined;
        }
      })
      .catch(function(error) {
        console.error("Error check existstence of document:  ", error);
        return undefined;
      });

    return promise;
  }

  async update_meta_field(tName, field, value) {
    var object = {}
    object[field] = value;
    firebase
      .firestore()
      .collection("data")
      .doc(tName)
      .update( object )
      .then(() => {
        return 1;
      })
      .catch(function(error) {
        console.log(error);
        return undefined;
      });
  }

  async update_meta(tName, meta) {
    var promise = firebase
      .firestore()
      .collection("data")
      .doc(tName)
      .update(Object.assign({}, meta))
      .then(() => {
        return 1;
      })
      .catch(function(error) {
        console.log(error);
        return undefined;
      });

    return promise;
  }

  update_by_key(tName, key, object) {
    var promise = firebase
      .firestore()
      .collection("data")
      .doc(tName)
      .collection("entries")
      .doc(key)
      .update(object)
      .then(() => {
        return 1;
      })
      .catch(function(error) {
        console.log(error);
        return undefined;
      });

    return promise;
  }

  // Push mit key durch firebase generiert
  write(tName, line) {
    var testRef = firebase
      .firestore()
      .collection("data")
      .doc(tName)
      .collection("entries")
      .doc();

    var promise = testRef
      .set(Object.assign({}, line))
      .then((docRef) => {
        console.log("Doc refx ", docRef);
        this.get_and_increment(tName, "doc_count")
        return testRef;
      })
      .catch(function(error) {
        console.error("   Failure : ", error);
        return null;
      });

    return promise;
  }

  async write_by_key(tName, key, line) {

    var x = await this.read_by_key(tName, key);

    var promise = firebase
      .firestore()
      .collection("data")
      .doc(tName)
      .collection("entries")
      .doc(key)
      .set(Object.assign({}, line))
      .then(() => {
        if (!x) {
          this.get_and_increment(tName,"doc_count")
        }
        return 1;
      })
      .catch(function(error) {
        console.log(error);
        return undefined;
      });

    
    return promise;
  }

  async get_and_increment(tName, counter_field) {
    var docRef = firebase
      .firestore()
      .collection("data")
      .doc(tName);

    let result;

    await firebase
      .firestore()
      .runTransaction(async function(transaction) {
        let line = null;
        console.log("   Reading current counter value for " + docRef);

        await transaction.get(docRef).then(function(doc) {
          if (doc.exists) {
            line = doc.data();
          }
        });

        console.log("Read line : ", JSON.stringify(line));

        // The data have not been found in firestore
        if (line == null) {
          console.log("   Failed reading value.");
          return Promise.reject(-1);
        }

        var nextId = line[counter_field] + 1;
        line[counter_field] = nextId;
        console.log("   Updating: " + nextId);
        await transaction.update(docRef, Object.assign({}, line));

        let account = nextId - 1;
        return account;
      })
      .then(function(account) {
        console.log("   Success : Account is " + account);
        result = account;
      })
      .catch(function(error) {
        console.error("   Failure : ", error);
        result = -1;
      });

    return result;
  }

  create_test_table() {
    var tName = "XY_Test";
    var promise = this.create_table(tName);

    this.write_by_key(tName, "1", {
      name: "Hans",
      date: new Date("2020-01-01"),
      age: 40,
    });

    this.write_by_key(tName, "2", {
      name: "Tom",
      date: new Date("2020-02-01"),
      age: 45,
    });

    this.write_by_key(tName, "3", {
      name: "Sepp",
      date: new Date("2020-03-01"),
      age: 50,
    });
  }
}

export { FirebaseTable };
